import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';

interface ComplaintStateWrapperProps {
  children: React.ReactNode;
  formHeaderTitle?: string;
  formHeaderDescription?: string | React.ReactNode;
}

const ComplaintStateWrapper: React.FC<ComplaintStateWrapperProps> = ({
  children,
}) => {
  const { sliderIndex } = useContext(TranslatingContainerContext)!;

  return (
    <Container>
      <Ul sliderIndex={sliderIndex}>
        {Array.from({ length: 3 }).map((_, index) => (
          <li
            key={index}
            className={
              index === sliderIndex
                ? 'highlight'
                : index < sliderIndex
                  ? 'completed'
                  : ''
            }
          >
            <span className={index === sliderIndex ? 'highlight' : ''}>
              Step {index + 1}
            </span>
          </li>
        ))}
      </Ul>
      <HorizontalLine />
      {children}
    </Container>
  );
};

export default ComplaintStateWrapper;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

interface ULProps {
  sliderIndex?: number;
}
const Ul = styled.ul<ULProps>`
  border: none;
  display: flex;
  align-items: center;
  gap: 32px;
  /* border: 1px solid red; */
  margin: 0;
  padding: 0;
  list-style: none;

  & > li {
    width: 16px;
    height: 16px;
    background-color: #d9d9d9;
    border-radius: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;

    & > span {
      display: none;
    }
  }

  & > li.highlight > span.highlight {
    display: block;
    color: white;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    z-index: 25;
    padding-left: 32px;
  }

  & > li::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 100%;

    z-index: 21;
    width: 32px;
    height: 1px;
    background-color: #d9d9d9;
  }

  & > li.highlight::before {
    content: ${(props) =>
      `"${props.sliderIndex !== undefined ? props.sliderIndex + 1 : 1}"`};

    top: 4px;
    position: absolute;
    left: 8px;

    z-index: 31;
    width: 25px;
    height: 24px;
    color: ${({ theme }) => theme.palette.blueColor};
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: white;
  }

  & > li.highlight {
    background-color: ${({ theme }) => theme.palette.blueColor};
    width: 112px;
    height: 32px;
    border-radius: 20px;
  }

  & > li:last-of-type::after {
    content: '';
    position: absolute;

    width: 0px;
    height: 0px;
  }

  & > li.completed {
    background-color: ${({ theme }) => theme.palette.blueColor};
  }

  & > li.completed::after {
    background-color: ${({ theme }) => theme.palette.blueColor};
  }
`;

const HorizontalLine = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.palette.borderColor};
  margin-bottom: 12px;
`;
